import { Alert } from "antd";
import { EtapaCadastroCota, FluxoResposta, NoFluxoCadastroCota } from "./cadastroCotaUsuario.types";
import { OnboardingFrame, OnboardingNavigationContext } from "./utils";
import { CadastroConcluido } from "./etapas/CadastroConcluido";
import { EtapaApartamento } from "./etapas/EtapaApartamento";
import { EtapaDisponibilidade } from "./etapas/EtapaDisponibilidade";
import { EtapaEmpreendimento } from "./etapas/EtapaEmpreendimento";
import { EtapaIdentificacaoCota } from "./etapas/EtapaIdentificacaoCota";
import { EtapaPeriodos } from "./etapas/EtapaPeriodos";
import { EtapaOportunidadesHospedagem } from "./etapas/EtapaOportunidadesHospedagem";
import { EtapaTitularidade } from "./etapas/EtapaTitularidade";
import { EtapaVenda } from "./etapas/EtapaVenda";
import { EtapaSituacaoCota } from "./etapas/EtapaSituacaoCota";
import { EtapaSaldoDevedor } from "./etapas/EtapaSaldoDevedor";
import { EtapaValorVenda } from "./etapas/EtapaValorVenda";
import { EtapaOutrosDetalhesVenda } from "./etapas/EtapaOutrosDetalhesVenda";
import { EtapaContratacao } from "./etapas/EtapaContratacao";
import { EtapaPagamentoPendente } from "./etapas/EtapaPagamentoPendente";
import { EtapaPagamentoConfirmado } from "./etapas/EtapaPagamentoConfirmado";
import { EtapaUtilizarVagaAssinatura } from "./etapas/EtapaUtilizarVagaAssinatura";

interface Props {
  fluxo: FluxoResposta;
  etapaExibida: EtapaCadastroCota;
  submitting: boolean;
  onConcluir: (payload: Record<string, unknown>) => Promise<void>;
  onVoltar?: () => void;
  etapaAnteriorNome?: string;
}

export const etapaDoNo: Record<NoFluxoCadastroCota, EtapaCadastroCota> = {
  EMPREENDIMENTO: "AGUARDANDO_EMPREENDIMENTO", APARTAMENTO: "AGUARDANDO_APARTAMENTO",
  IDENTIFICACAO_COTA: "AGUARDANDO_IDENTIFICACAO_COTA", TITULARIDADE: "AGUARDANDO_TITULARIDADE",
  DISPONIBILIDADE: "AGUARDANDO_DISPONIBILIDADE", PERIODOS: "AGUARDANDO_PERIODOS",
  COMO_FUNCIONA_DEFINICAO_PERIODOS: "AGUARDANDO_PERIODOS",
  EXISTENCIA_PERIODOS: "AGUARDANDO_PERIODOS",
  DEFINICAO_PERIODOS: "AGUARDANDO_PERIODOS", LEMBRETE_PERIODOS: "AGUARDANDO_PERIODOS",
  INFORMAR_PERIODOS: "AGUARDANDO_PERIODOS",
  VENDA: "AGUARDANDO_VENDA", DESEJA_VENDER: "AGUARDANDO_VENDA", SITUACAO_COTA: "AGUARDANDO_VENDA", SALDO_DEVEDOR: "AGUARDANDO_VENDA",
  VALOR_VENDA: "AGUARDANDO_VENDA", OUTROS_DETALHES_VENDA: "AGUARDANDO_VENDA",
  CONTRATACAO: "AGUARDANDO_CONTRATACAO",
  PAGAMENTO_PENDENTE: "PAGAMENTO_PENDENTE",
  PAGAMENTO_CONFIRMADO: "PAGAMENTO_CONFIRMADO",
  UTILIZAR_VAGA_ASSINATURA: "UTILIZAR_VAGA_ASSINATURA",
  OPORTUNIDADES_HOSPEDAGEM: "AGUARDANDO_OPORTUNIDADES_HOSPEDAGEM",
  CONCLUSAO: "CONCLUIDO",
};

export function EtapaCadastroRenderer({
  fluxo,
  etapaExibida,
  submitting,
  onConcluir,
  onVoltar,
  etapaAnteriorNome,
}: Props) {
  let conteudo;
  switch (etapaExibida) {
    case "AGUARDANDO_EMPREENDIMENTO":
      conteudo = (
        <EtapaEmpreendimento
          fluxo={fluxo}
          submitting={submitting}
          onConcluir={onConcluir}
        />
      );
      break;
    case "AGUARDANDO_APARTAMENTO":
      conteudo = (
        <EtapaApartamento
          fluxo={fluxo}
          submitting={submitting}
          onConcluir={onConcluir}
        />
      );
      break;
    case "AGUARDANDO_IDENTIFICACAO_COTA":
      conteudo = (
        <EtapaIdentificacaoCota
          fluxo={fluxo}
          submitting={submitting}
          onConcluir={onConcluir}
        />
      );
      break;
    case "AGUARDANDO_TITULARIDADE":
      conteudo = (
        <EtapaTitularidade
          fluxo={fluxo}
          submitting={submitting}
          onConcluir={onConcluir}
        />
      );
      break;
    case "AGUARDANDO_DISPONIBILIDADE":
      conteudo = (
        <EtapaDisponibilidade
          fluxo={fluxo}
          submitting={submitting}
          onConcluir={onConcluir}
        />
      );
      break;
    case "AGUARDANDO_PERIODOS":
      conteudo = (
        <EtapaPeriodos
          key={`${fluxo.etapaAtual}:${fluxo.noAtual}:${fluxo.detalhesEtapa?.pergunta ?? ""}:${fluxo.detalhesEtapa?.modoPeriodo ?? ""}:${fluxo.detalhesEtapa?.escopoDisponibilizacao ?? ""}`}
          fluxo={fluxo}
          submitting={submitting}
          onConcluir={onConcluir}
        />
      );
      break;
    case "AGUARDANDO_VENDA":
      conteudo = (
        fluxo.noAtual === "CONTRATACAO" ? (
          <EtapaContratacao fluxo={fluxo} submitting={submitting} onConcluir={onConcluir} />
        ) : (fluxo.noAtual === "OUTROS_DETALHES_VENDA" || fluxo.detalhesEtapa?.pergunta === "OUTROS_DETALHES_VENDA") ? (
          <EtapaOutrosDetalhesVenda fluxo={fluxo} submitting={submitting} onConcluir={onConcluir} />
        ) : (fluxo.noAtual === "VALOR_VENDA" || fluxo.detalhesEtapa?.pergunta === "VALOR_VENDA") ? (
          <EtapaValorVenda fluxo={fluxo} submitting={submitting} onConcluir={onConcluir} />
        ) : (fluxo.noAtual === "SALDO_DEVEDOR" || fluxo.detalhesEtapa?.pergunta === "SALDO_DEVEDOR") ? (
          <EtapaSaldoDevedor fluxo={fluxo} submitting={submitting} onConcluir={onConcluir} />
        ) : (fluxo.noAtual === "SITUACAO_COTA" || fluxo.detalhesEtapa?.pergunta === "SITUACAO_COTA") ? (
          <EtapaSituacaoCota fluxo={fluxo} submitting={submitting} onConcluir={onConcluir} />
        ) : (
          <EtapaVenda fluxo={fluxo} submitting={submitting} onConcluir={onConcluir} />
        )
      );
      break;
    case "AGUARDANDO_CONTRATACAO":
      conteudo = (
        fluxo.noAtual === "PAGAMENTO_PENDENTE" ? (
          <EtapaPagamentoPendente
            fluxo={fluxo}
            submitting={submitting}
            onConcluir={onConcluir}
          />
        ) : fluxo.noAtual === "PAGAMENTO_CONFIRMADO" ? (
          <EtapaPagamentoConfirmado
            fluxo={fluxo}
            submitting={submitting}
            onConcluir={onConcluir}
          />
        ) : fluxo.noAtual === "UTILIZAR_VAGA_ASSINATURA" ? (
          <EtapaUtilizarVagaAssinatura
            fluxo={fluxo}
            submitting={submitting}
            onConcluir={onConcluir}
          />
        ) : (
          <EtapaContratacao
            fluxo={fluxo}
            submitting={submitting}
            onConcluir={onConcluir}
          />
        )
      );
      break;
    case "PAGAMENTO_PENDENTE":
      conteudo = (
        <EtapaPagamentoPendente
          fluxo={fluxo}
          submitting={submitting}
          onConcluir={onConcluir}
        />
      );
      break;
    case "PAGAMENTO_CONFIRMADO":
      conteudo = (
        <EtapaPagamentoConfirmado
          fluxo={fluxo}
          submitting={submitting}
          onConcluir={onConcluir}
        />
      );
      break;
    case "UTILIZAR_VAGA_ASSINATURA":
      conteudo = (
        <EtapaUtilizarVagaAssinatura
          fluxo={fluxo}
          submitting={submitting}
          onConcluir={onConcluir}
        />
      );
      break;
    case "AGUARDANDO_OPORTUNIDADES_HOSPEDAGEM":
      conteudo = (
        <EtapaOportunidadesHospedagem
          key={`${fluxo.cadastroCotaUsuarioId}:${fluxo.detalhesEtapa?.pergunta ?? ""}`}
          fluxo={fluxo}
          submitting={submitting}
          onConcluir={onConcluir}
        />
      );
      break;
    case "CONCLUIDO":
      conteudo = <CadastroConcluido fluxo={fluxo} />; break;
    default:
      conteudo = (
        <OnboardingFrame fluxo={fluxo} title="Etapa não identificada">
          <Alert
            type="warning"
            showIcon
            message="Não foi possível identificar esta etapa do cadastro."
            description="Recarregue a página para tentar novamente. Se o problema persistir, entre em contato com o suporte."
          />
        </OnboardingFrame>
      );
  }

  return <OnboardingNavigationContext.Provider value={{ onVoltar, etapaAnteriorNome, etapaExibida }}>{conteudo}</OnboardingNavigationContext.Provider>;
}
